import Field from './Field'

export default function FieldDatetime (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'date-picker'
  this.subType = 'datetime'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldDatetime.js